// extracted by mini-css-extract-plugin
export var container = "slideshow-module--container--19_U_";
export var backgroundImage = "slideshow-module--backgroundImage--1vCMF";
export var presentation = "slideshow-module--presentation--302RT";
export var content = "slideshow-module--content--3NZfG";
export var slideshowWrapper = "slideshow-module--slideshowWrapper--2hZpT";
export var swiper = "slideshow-module--swiper--3lK3a";
export var slide = "slideshow-module--slide--1BhwO";
export var overlay = "slideshow-module--overlay--1gHJu";
export var overlayContent = "slideshow-module--overlayContent--sR6Hf";
export var overlayBackground = "slideshow-module--overlayBackground--1Am7A";
export var overlayText = "slideshow-module--overlayText--NxRQO";
export var slideImage = "slideshow-module--slideImage--ZOLPd";
export var pagination = "slideshow-module--pagination--hZTiG";
export var navigation = "slideshow-module--navigation--2PPcI";
export var navigationPrev = "slideshow-module--navigationPrev--15j5j";
export var navigationNext = "slideshow-module--navigationNext--3ybCg";
export var buttonContainer = "slideshow-module--buttonContainer--371SG";
export var closeButton = "slideshow-module--closeButton--cvADh";